import getStorageData from "../Utils/getStorageData";
import { Images } from "./images";

const useRoutes = () => {
  const userType = getStorageData().userType;

  let route = [];

  if (userType === 0) {
    route = [
      {
        img: Images.Search,
        activeImg: Images.ActiveSearch,
        path: "/search",
        name: "Search",
        isShow: 1,
      },
      {
        img: Images.Premises,
        activeImg: Images.ActivePremises,
        path: "/premises",
        name: "Premises",
        isShow: 0,
      },
      {
        img: Images.SubAdmin,
        activeImg: Images.ActiveSubAdmin,
        path: "/sub-admins",
        name: "Sub Admins",
        isShow: 0,
      },
      {
        img: Images.SubAdmin,
        activeImg: Images.ActiveSubAdmin,
        path: "/sub-admins/permissions",
        name: "Sub Admin Permissions",
        isShow: 0,
      },
      {
        img: Images.ServicePerson,
        activeImg: Images.ActiveServicePerson,
        path: "/service-person",
        name: "Service Person",
        isShow: 0,
      },
      // {
      //     img: Images.Premises,
      //     activeImg: Images.ActivePremises,
      //     path: "/area",
      //     name: "Area",
      //     isShow: 1
      // },
      {
        img: Images.AdminDashboard,
        activeImg: Images.ActiveAdminDashboard,
        path: "/dashboard/request-dashboard",
        name: "Dashboard",
        isShow: 1,
      },
      {
        img: Images.AdminDashboard,
        activeImg: Images.ActiveAdminDashboard,
        path: "/dashboard/request-dashboard/device-dashboard",
        name: "User & Device Dashboard",
        isShow: 0,
      },
      {
        img: Images.SubAdmin,
        activeImg: Images.ActiveSubAdmin,
        path: "/users/profile/:id",
        name: "Profile List",
        isShow: 0,
      },
      {
        img: Images.SubAdmin,
        activeImg: Images.ActiveSubAdmin,
        path: "/users/profile/device/:slaveId",
        name: "Profile List",
        isShow: 0,
      },
      {
        img: Images.ScheduleLog,
        activeImg: Images.ActiveScheduleLog,
        path: "/schedules-logs",
        name: "Schedule Logs",
        isShow: 1,
      },
      {
        img: Images.ScheduleLog,
        activeImg: Images.ActiveScheduleLog,
        path: "/feedback",
        name: "Feedback",
        isShow: 0,
      },
      {
        img: Images.staticOTP,
        activeImg: Images.ActiveStaticOTP,
        path: "/static-otp",
        name: "Static OTP",
        isShow: 1,
      },
      {
        img: Images.SendNotification,
        activeImg: Images.ActiveSendNotification,
        path: "/send-notification",
        name: "Notification",
        isShow: 1,
      },
      {
        img: Images.SendNotification,
        activeImg: Images.ActiveSendNotification,
        path: "/templates",
        name: "Templates",
        isShow: 1,
      },
      {
        img: Images.DebugDevice,
        activeImg: Images.ActiveDebugDevice,
        path: "/debug-device",
        name: "Debug Device",
        isShow: 1,
      },
      {
        img: Images.DebugDevice,
        activeImg: Images.ActiveDebugDevice,
        path: "/debug-device-details/:slave",
        name: "Debug Device",
        isShow: 0,
      },
      {
        img: Images.Firmware,
        activeImg: Images.ActiveFirmware,
        path: "/firmware",
        name: "Firmware",
        isShow: 1,
      },
      {
        img: Images.Logs,
        activeImg: Images.ActiveLogs,
        path: "/logs",
        name: "Logs",
        isShow: 1,
      },
      {
        img: Images.Backup,
        activeImg: Images.ActiveBackup,
        path: "/backup",
        name: "Backup",
        isShow: 1,
      },
      {
        img: Images.Premises,
        activeImg: Images.ActivePremises,
        path: "/master",
        name: "Master",
        isShow: 0,
      },
      {
        img: Images.Settings,
        activeImg: Images.ActiveSetting,
        path: "/settings",
        name: "Settings",
        isShow: 1,
      },
      // {
      //     img: Images.DebugDevice,
      //     activeImg: Images.ActiveDebugDevice,
      //     path: "/testing",
      //     name: "Testing",
      //     isShow: 1
      // },
      // {
      //     img: Images.DebugDevice,
      //     activeImg: Images.ActiveDebugDevice,
      //     path: "/testing/testing-of-details/:id",
      //     name: "Testing",
      //     isShow: 0
      // },
      // {
      //     img: Images.DebugDevice,
      //     activeImg: Images.ActiveDebugDevice,
      //     path: "/testing/testing-details-of-details/:id",
      //     name: "Testing",
      //     isShow: 0
      // },
    ];
  }
  return route;
};

export default useRoutes;
